import React from 'react';
import { PropTypes } from 'prop-types';

import LoadingWrapper from 'components/Common/LoadingWrapper';

const SiteLoading = ({ title, caption, isLoaded, className }) => (
  <div className="site-loader login-container">
    <div className="login-form">
      <div className="login-logo-container">
        <div className="login-logo" />
        <div className="powered-by"><span className="taina-brand">Powered by T<span className="taina-ai">AI</span>NA</span></div>
      </div>

      <h1 className="taina-brand">
        T<span className="taina-ai">AI</span>NA Fully Automated Tax Form Validator and Classifier
      </h1>
      <LoadingWrapper loaded={ isLoaded } />
      <h1 className={ `taina-brand ${ className }` }> { title !== '' && <div className="mb"><u>{title}</u></div>} { <span>{ caption }</span> }</h1>
    </div>
  </div>
);

SiteLoading.propTypes = {
  isLoaded: PropTypes.bool,
  className: PropTypes.string,
  caption: PropTypes.string,
  title: PropTypes.string
};

SiteLoading.defaultProps = {
  isLoaded: false,
  className: null,
  title: '',
  caption: 'We are getting the system ready. Please wait...'
};

export default SiteLoading;
